import { DefaultService } from '@/services/DefaultService';


export default class ParametroService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findParametroByNome( nome ) {
        return this._http.get(`${this._env}/parameters/parametro/${nome}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }


}